module.exports = __webpack_public_path__ + "static/media/header-desktop.b6832f64.jpg";